/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindProductCollectionValuesQueryResponse,
  FindProductCollectionValuesQueryParams,
} from "../types/FindProductCollectionValues.ts"

export const findProductCollectionValuesQueryKey = (
  params?: FindProductCollectionValuesQueryParams
) =>
  [
    { url: "/v1/product/find-product-collection-values" },
    ...(params ? [params] : []),
  ] as const

export type FindProductCollectionValuesQueryKey = ReturnType<
  typeof findProductCollectionValuesQueryKey
>

/**
 * @summary Find product collection values
 * {@link /v1/product/find-product-collection-values}
 */
export async function findProductCollectionValues(
  params?: FindProductCollectionValuesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindProductCollectionValuesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/product/find-product-collection-values`,
    params,
    ...requestConfig,
  })
  return res
}

export function findProductCollectionValuesQueryOptions(
  params?: FindProductCollectionValuesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = findProductCollectionValuesQueryKey(params)
  return queryOptions<
    ResponseConfig<FindProductCollectionValuesQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindProductCollectionValuesQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return findProductCollectionValues(params, config)
    },
  })
}

/**
 * @summary Find product collection values
 * {@link /v1/product/find-product-collection-values}
 */
export function useFindProductCollectionValues<
  TData = ResponseConfig<FindProductCollectionValuesQueryResponse>,
  TQueryData = ResponseConfig<FindProductCollectionValuesQueryResponse>,
  TQueryKey extends QueryKey = FindProductCollectionValuesQueryKey,
>(
  params?: FindProductCollectionValuesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindProductCollectionValuesQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey =
    queryOptions?.queryKey ?? findProductCollectionValuesQueryKey(params)

  const query = useQuery(
    {
      ...findProductCollectionValuesQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
